import { Backend } from '@/_axios';

export default {
  LOAD_USERS: function ({ commit }) {
    Backend.get('/api/users').then((response) => {
      commit('SET_USERS', response.data);
    }, (err) => {
      console.log(err);
    });
  },
  LOAD_SINGLE_USER: function ({ commit }, id) {
    Backend.get(`/api/users/${id}`).then((response) => {
      commit('LOAD_SINGLE_USER', response.data);
    }, (err) => {
      console.log(err);
    });
  },
  LOAD_PERMISSIONS: function ({ commit }) {
    Backend.get('/api/permissions').then((response) => {
      commit('SET_PERMISSIONS', response.data);
    }, (err) => {
      console.log(err);
    });
  },
  LOAD_ROLES: function ({ commit }) {
    Backend.get('/api/roles').then((response) => {
      commit('SET_ROLES', response.data);
    }, (err) => {
      console.log(err);
    });
  },
  UPDATE_USER: function ({ commit }, user) {
    Backend.put(`/api/users/${user.id}`, {
      user: user
    }).then((response) => {
      commit('CLEAR_SINGLE_USER', response.data);
      commit('UPDATE_USER', user);
    }, (err) => {
      commit('ERROR_UPDATE_USER');
      console.log(err);
    });
  },
  DELETE_USER: function ({ commit }, id) {
    Backend.post('/api/delete_user', { id: id }).then((response) => {
      // return response.data.data;
      commit('DELETE_USER', id);
    }, (err) => {
      commit('ERROR_DELETE_USER');
      console.log(err);
    });
  },
  CREATE_ROLE: function ({ commit }, { name, display_name, description }) {
    Backend.post('/api/create-role', { name: name, display_name: display_name, description: description }).then((response) => {
      commit('ADD_ROLE', response.data);
    }, (err) => {
      console.log(err);
    });
  },
  DELETE_ROLE: function ({ commit }, id) {
    Backend.delete('/api/delete-role', { params: { id: id } }).then((response) => {
      commit('REMOVE_ROLE', id);
    }, (err) => {
      console.log(err);
    });
  },
  UPDATE_PERMISSIONS: function ({ commit }, { permissions, id }) {
    Backend.patch('/api/update-role-permissions', { permissions: permissions, id: id }).then((response) => {
      commit('UPDATE_PERMISSIONS', response.data);
    }, (err) => {
      console.log(err);
    });
  },
  CHANGE_PASSWORD: function ({ commit }, { password, userid }) {
    Backend.post('/api/change-password', { password: password, userid: userid }).then((response) => {
      // console.log("RESPONSE" + JSON.stringify(response.data));
      commit('PASSWORD_UPDATE', response.data);
    }, (err) => {
      console.log(err);
    });
  }
};
